import { zClientCommonSchema } from "./client.common";
export const zClientSchemaDto = zClientCommonSchema;
export const zClientSchemaCreateDto = zClientSchemaDto.omit({ id: true });
